var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Element_24/Autre/Info/Fill/Noir",
    transform: "scale(.75)",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd",
    opacity: 0.8,
    strokeWidth: 1.3333
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 4c-6.628 0-12 5.372-12 12s5.372 12 12 12 12-5.372 12-12-5.372-12-12-12m0 2.6667c5.1453 0 9.3333 4.1866 9.3333 9.3333s-4.188 9.3333-9.3333 9.3333-9.3333-4.1866-9.3333-9.3333 4.188-9.3333 9.3333-9.3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 12.667c-0.7373 0-1.3333-0.5974-1.3333-1.3334s0.596-1.3333 1.3333-1.3333c0.7374 0 1.3334 0.5973 1.3334 1.3333s-0.596 1.3334-1.3334 1.3334zm1.3334 7.8786c0 0.804-0.596 1.4547-1.3334 1.4547-0.7373 0-1.3333-0.6507-1.3333-1.4547v-5.0906c0-0.804 0.596-1.4547 1.3333-1.4547 0.7374 0 1.3334 0.6507 1.3334 1.4547z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ace57bec6156fd4d35b0ae90b3279b23.svg";
export { ForwardRef as ReactComponent };